export const DEFAULT_DOWNLOAD_FILENAME = "logs.tar.gz";
export const DOWNLOAD_RESET_DELAY = 100;
export const DATE_FORMAT_REGEX = /^\d{4}-\d{2}-\d{2}$/;
